import client from '@/utils/client';

export const register = async (payload: object) => {
  try {
    const response = await client.post(`/auth/register`, {
      ...payload,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
